module.exports = __webpack_public_path__ + "img/template.a3ed7887.png";